// import tagsApi from "../../api/tags";


const state = () => ({
    bookingsTagsObject: {},
    mimksTagsObject: {},
})

const actions = {
    // async getBookingsTags({ commit, state, rootGetters }, bookingIds = []) {
    //     const bookingAvailableIds = Object.keys(state.bookingsTagsObject)
    //     bookingIds = bookingIds.filter(id => !bookingAvailableIds.includes(id))
    //
    //     const bookings = await tagsApi.getBookingsTags(bookingIds, rootGetters['user/getUserSegmentId'])
    //     commit('setBookingsTags', bookings)
    // },
    // async getMimksTags({ commit, state, rootGetters }, mimksIds = []) {
    //     const mimksAvailableIds = Object.keys(state.mimksTagsObject)
    //     mimksIds = mimksIds.filter(id => !mimksAvailableIds.includes(id))
    //
    //     const bookings = await tagsApi.getMimksTags(mimksIds, rootGetters['user/getUserSegmentId'])
    //     commit('setMimksTags', bookings)
    // }
}

const mutations = {
    setBookingsTags(state, payload = []) {
        const newBookingsTagsObject = {...state.bookingsTagsObject}
        payload.forEach(booking => {
            newBookingsTagsObject[booking.booking_id] = booking.tags
        })

        state.bookingsTagsObject = newBookingsTagsObject
    },
    setMimksTags(state, payload = []) {
        const newMimksTagsObject = {...state.mimksTagsObject}
        payload.forEach(mimk => {
            newMimksTagsObject[`${mimk.tcm_id}`] = mimk.tags
        })

        state.mimksTagsObject = newMimksTagsObject
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};